import { UrlGeneratorTrace } from 'api';

export const postExportRedirectUrlSelector = (d: UrlGeneratorTrace) =>
  d.properties?.postExportRedirectUrl;
